'use client'

import { motion } from "framer-motion"
import { Clock, Phone, Mail } from 'lucide-react'

export default function Footer() {
  return (
    <footer className="bg-[#F8F7FF] px-4 py-12 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-6">
            <h2 className="text-2xl font-bold">
              <span className="text-[#00205B]">Tax</span>
              <span className="text-blue-600">Eases</span>
            </h2>
            <p className="text-gray-600">
              D-11 Green Park Main, Delhi,<br />
              India -110016
            </p>
            <div className="flex items-center gap-2 text-gray-600">
              <Phone className="w-5 h-5 text-blue-600" />
              <a href="tel:+919958229051" className="hover:text-blue-600">
                +91 9958229051
              </a>
            </div>
            <div className="flex items-center gap-2 text-gray-600">
              <Mail className="w-5 h-5 text-blue-600" />
              <a href="mailto:taxeases1@gmail.com" className="hover:text-blue-600">
                taxeases1@gmail.com
              </a>
            </div>
            <div className="flex items-start gap-2 text-gray-600">
              <Clock className="w-5 h-5 text-blue-600 flex-shrink-0" />
              <div>
                <p>Mon - Sat: 8 am - 5 pm,</p>
                <p>Sunday: <span className="text-red-500">CLOSED</span></p>
              </div>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#00205B]">Company</h3>
            <ul className="space-y-3">
              {['Blog', 'Pricing', 'About Us', 'Contact us', 'Testimonials'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-gray-600 hover:text-blue-600">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#00205B]">Support</h3>
            <ul className="space-y-3">
              {['Legal policy', 'Status policy', 'Privacy policy', 'Terms of service'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-gray-600 hover:text-blue-600">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#00205B]">Our Newsletter</h3>
            <p className="text-gray-600 mb-4">
              Sign up to TaxEases weekly newsletter to get the latest updates.
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Enter your E-mail"
                className="flex-1 px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
              />
              <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors">
                SUBSCRIBE
              </button>
            </div>
            <div className="flex gap-4 mt-6">
              {['facebook', 'instagram', 'twitter', 'youtube'].map((social) => (
                <a
                  key={social}
                  href="#"
                  className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"
                >
                  <img
                    src={`/placeholder.svg?height=20&width=20`}
                    alt={social}
                    className="w-5 h-5"
                  />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200 text-center text-gray-600">
          <p>Copyright © TaxEases | All Right Reserved</p>
        </div>
      </div>
    </footer>
  )
}

